/* StorePro V1 — comportamiento global (módulo). Se integra con el carrito de Horizon. */
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const $ = (s, c = document) => c.querySelector(s);
const $$ = (s, c = document) => [...c.querySelectorAll(s)];
const CFG = window.SPCFG || {};
/* global Theme */
const routes = Object.assign({ cart_add_url: '/cart/add', cart_url: '/cart' },
  (typeof Theme !== 'undefined' && Theme.routes) || {});

/* ---------- Dinero (COP, sin decimales) ---------- */
function money(cents) {
  const v = Math.round(Number(cents) / 100);
  return '$' + v.toLocaleString('es-CO');
}

/* ---------- Scroll: en escritorio Horizon hace scroll dentro de .page-wrapper ---------- */
const wrapper = $('.page-wrapper');
const scrollTop = () => Math.max(window.scrollY || 0, wrapper ? wrapper.scrollTop : 0);
function onScroll(fn) {
  window.addEventListener('scroll', fn, { passive: true });
  if (wrapper) wrapper.addEventListener('scroll', fn, { passive: true });
}

/* ---------- Toast ---------- */
let tt;
function toast(msg) {
  const t = $('#sp-toast'); if (!t) return;
  t.querySelector('span').textContent = msg; t.classList.add('on');
  clearTimeout(tt); tt = setTimeout(() => t.classList.remove('on'), 2600);
}

/* ---------- Carrito ---------- */
async function getCart() {
  const r = await fetch(`${routes.cart_url}.js`, { credentials: 'same-origin' });
  return r.json();
}
function paintCart(cart) {
  $$('.sp-cart-count').forEach(el => {
    el.textContent = cart.item_count; el.classList.toggle('on', cart.item_count > 0);
  });
  $$('[data-sp-shipbar]').forEach(bar => {
    const free = CFG.freeShip || 20000000, total = cart.total_price, rest = free - total;
    const msg = bar.querySelector('.msg'), fill = bar.querySelector('.fill');
    if (msg) msg.innerHTML = total <= 0 ? `Envío <b>gratis</b> en pedidos desde ${money(free)}`
      : rest > 0 ? `Te faltan <b>${money(rest)}</b> para tener <b>envío gratis</b>`
      : `<b>¡Listo! Tu envío es gratis</b> · llega asegurado`;
    if (fill) fill.style.width = Math.min(100, (total / free) * 100) + '%';
  });
}
async function refreshCart() { try { paintCart(await getCart()); } catch (e) {} }

function openCartDrawer() {
  const d = document.getElementById('cart-drawer');
  if (d && typeof d.open === 'function') { d.open(); return true; }
  return false;
}

async function addToCart(variantId, quantity = 1, opts = {}) {
  const source = opts.source || document.body;
  const fd = new FormData();
  fd.append('id', variantId); fd.append('quantity', quantity);
  const sectionIds = $$('cart-items-component').map(el => el.dataset.sectionId).filter(Boolean);
  if (sectionIds.length) fd.append('sections', sectionIds.join(','));
  const deferred = CartLinesUpdateEvent.createPromise();
  source.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add', context: 'product',
    lines: [{ merchandiseId: String(variantId), quantity: Number(quantity) }],
    promise: deferred.promise
  }));
  try {
    const res = await fetch(routes.cart_add_url, {
      method: 'POST', body: fd, credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
    }).then(r => r.json());
    const cart = await getCart();
    if (res.status) {
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items, source: 'product-form-component', sourceId: 'sp-v1', itemCount: quantity } });
      toast(res.description || 'No pudimos agregar este producto');
      return false;
    }
    deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: false, items: cart.items, source: 'product-form-component', sourceId: 'sp-v1', itemCount: quantity, productId: opts.productId, sections: res.sections } });
    paintCart(cart);
    $$('.sp-cart-count').forEach(el => { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); });
    if (opts.open !== false && !openCartDrawer()) toast('Agregado a tu carrito');
    return true;
  } catch (e) {
    deferred.reject(e); toast('Error de conexión. Intenta de nuevo.'); return false;
  }
}
function buyNow(variantId, quantity = 1) {
  window.location.href = `/cart/${variantId}:${quantity}`;
}
window.SP = Object.assign(window.SP || {}, { addToCart, buyNow, money, toast, refreshCart, openCartDrawer, onScroll, scrollTop });
document.addEventListener(StandardEvents.cartLinesUpdate, e => {
  if (e.promise) e.promise.then(() => refreshCart()).catch(() => {}); else refreshCart();
});

/* ---------- Clics globales ---------- */
document.addEventListener('click', e => {
  const q = e.target.closest('[data-sp-add]');
  if (q) {
    e.preventDefault();
    if (q.dataset.multi === 'true') { window.location.href = q.dataset.url; return; }
    q.classList.add('is-loading');
    addToCart(q.dataset.spAdd, 1, { source: q }).finally(() => q.classList.remove('is-loading'));
    return;
  }
  if (e.target.closest('[data-sp-cart]')) {
    if (openCartDrawer()) e.preventDefault();
    return;
  }
  if (e.target.closest('[data-sp-menu]')) { e.preventDefault(); $('#sp-mnav')?.classList.add('on'); $('#sp-scrim')?.classList.add('on'); return; }
  if (e.target.closest('[data-sp-close]') || e.target.id === 'sp-scrim') { $$('.sp-mnav').forEach(m => m.classList.remove('on')); $('#sp-scrim')?.classList.remove('on'); }
});
document.addEventListener('keydown', e => { if (e.key === 'Escape') { $('#sp-mnav')?.classList.remove('on'); $('#sp-scrim')?.classList.remove('on'); } });

/* ---------- Barra de anuncios rotativa ---------- */
$$('.sp-ann-rot').forEach(rot => {
  const items = $$(':scope > span', rot); if (items.length < 2) { items[0]?.classList.add('on'); return; }
  let i = 0; items[0].classList.add('on');
  setInterval(() => {
    const prev = i; items[i].classList.remove('on'); items[i].classList.add('out');
    setTimeout(() => items[prev].classList.remove('out'), 600);
    i = (i + 1) % items.length; items[i].classList.add('on');
  }, 4200);
});

/* ---------- Header con sombra al hacer scroll ---------- */
const hdr = $('.sp-hdr');
if (hdr) { const f = () => hdr.classList.toggle('scrolled', scrollTop() > 8); onScroll(f); f(); }

/* ---------- Animaciones de entrada ---------- */
const io = new IntersectionObserver(es => es.forEach(x => { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } }), { rootMargin: '0px 0px -8% 0px' });
$$('.sp-rv').forEach(el => io.observe(el));

/* ---------- Fechas de entrega (hora Colombia) ---------- */
const DAYS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'], MON = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
const bogota = () => new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Bogota' }));
const addBiz = (d, n) => { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; } return d; };
const fmt = d => `${DAYS[d.getDay()]} ${d.getDate()} ${MON[d.getMonth()]}`;
function shipInfo() {
  const now = bogota(), cut = new Date(now); cut.setHours(CFG.cutoff ?? 14, 0, 0, 0);
  const today = now.getDay() !== 0 && now < cut, ship = today ? now : addBiz(now, 1);
  return { now, today, cut, ship, from: addBiz(ship, CFG.dMin || 2), to: addBiz(ship, CFG.dMax || 7) };
}
window.SP.shipInfo = shipInfo; window.SP.fmtDate = fmt;
function paintEta() {
  const s = shipInfo();
  $$('[data-sp-eta]').forEach(el => { el.innerHTML = `entre el <b>${fmt(s.from)}</b> y el <b>${fmt(s.to)}</b>`; });
  $$('[data-sp-cutoff]').forEach(el => {
    if (s.today) { const m = Math.floor((s.cut - s.now) / 60000); el.innerHTML = `Pide en las próximas <b>${Math.floor(m / 60)} h ${m % 60} min</b> y sale hoy`; }
    else el.innerHTML = `Pide ahora y sale <b>${s.now.getDay() === 6 && s.now >= s.cut ? 'el lunes' : 'mañana'}</b> a primera hora`;
  });
  $$('[data-sp-clock]').forEach(el => {
    el.textContent = s.now.toLocaleTimeString('es-CO', { hour: 'numeric', minute: '2-digit', hour12: true }).replace(/\s?a\.?\s?m\.?/i, ' a. m.').replace(/\s?p\.?\s?m\.?/i, ' p. m.');
  });
  $$('[data-sp-arrive]').forEach(el => { el.innerHTML = `Pide hoy y llega desde el <b>${fmt(s.from)}</b>`; });
}
paintEta(); setInterval(paintEta, 30000);

/* ---------- Bisel decorativo del hero ---------- */
$$('[data-sp-ticks]').forEach(g => {
  let s = '';
  for (let i = 0; i < 60; i++) { const a = i * 6 * Math.PI / 180, l = i % 5 === 0 ? 8 : 3.5, r1 = 94, r2 = r1 - l; s += `<line x1="${100 + r1 * Math.sin(a)}" y1="${100 - r1 * Math.cos(a)}" x2="${100 + r2 * Math.sin(a)}" y2="${100 - r2 * Math.cos(a)}" stroke="rgba(255,255,255,${i % 5 === 0 ? .38 : .14})" stroke-width="${i % 5 === 0 ? 1.2 : .8}"/>`; }
  g.innerHTML = s;
});

/* ---------- Filtros por pestañas (grillas) ---------- */
$$('[data-sp-tabs]').forEach(box => {
  const grid = document.getElementById(box.dataset.spTabs); if (!grid) return;
  $$('.sp-tab', box).forEach(t => t.addEventListener('click', () => {
    $$('.sp-tab', box).forEach(x => { x.classList.remove('on'); x.setAttribute('aria-selected', 'false'); });
    t.classList.add('on'); t.setAttribute('aria-selected', 'true');
    const f = t.dataset.f;
    $$(':scope > *', grid).forEach(c => { c.style.display = (f === 'all' || (c.dataset.c || '').split(' ').includes(f)) ? '' : 'none'; });
  }));
});

refreshCart();

/* ---------- Contador Black Days ---------- */
$$('[data-sp-bd]').forEach(root => {
  const end = new Date(root.dataset.spBd).getTime();
  if (!end || isNaN(end)) return;
  const els = {}; $$('[data-f]', root).forEach(e => { els[e.dataset.f] = e; });
  const sub = root.querySelector('[data-sp-bd-sub]');
  if (sub && !sub.textContent.trim()) {
    const d = new Date(end), M = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    const co = new Date(d.toLocaleString('en-US', { timeZone: 'America/Bogota' }));
    sub.textContent = `Termina el ${co.getDate()} de ${M[co.getMonth()]}`;
  }
  const pad = n => String(n).padStart(2, '0');
  let timer;
  const tick = first => {
    const ms = end - Date.now();
    if (ms <= 0) { root.hidden = true; clearInterval(timer); return; }
    const v = { d: Math.min(99, Math.floor(ms / 864e5)), h: Math.floor(ms % 864e5 / 36e5), m: Math.floor(ms % 36e5 / 6e4), s: Math.floor(ms % 6e4 / 1e3) };
    for (const k of 'dhms') {
      const t = pad(v[k]);
      for (let i = 0; i < 2; i++) {
        const e = els[k + i]; if (!e || e.textContent === t[i]) continue;
        e.textContent = t[i];
        if (!first) { e.classList.remove('tick'); void e.offsetWidth; e.classList.add('tick'); }
      }
    }
    root.hidden = false;
  };
  tick(true); timer = setInterval(() => tick(false), 1000);
});
